export default function cepMask(numbers) {
  if (!numbers) return ''

  let rawNumbers = String(numbers)

  rawNumbers = rawNumbers.replace(/[^0-9]/g, '')

  return rawNumbers.slice(0, 8)
}
